export enum ProposalLayoutName {
  Default = 'default',
}
